import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


// import { CarouselModule } from 'ngx-bootstrap/carousel';
// import { InfiniteScrollModule } from 'angular2-infinite-scroll';
// import { MyDatePickerModule } from 'mydatepicker';

import { SharedAppModule } from '../app.shared.module';
import { TruncatePipe } from '../pipe/exponential-strength.pipe';

// import { UsersComponent } from './users.component';
import { AdvertiserComponent } from './advertiser.component';
import { AdvertiserRoutingModule } from './advertiser-routing.module';

// import { LandingComponent } from './landing/landing.component';
// import { AdLoginComponent } from './ad-login/ad-login.component';
// import { AdSignupComponent } from './ad-signup/ad-signup.component';
// import { AdlandingComponent } from './adlanding/adlanding.component';
// import { InterestComponent } from './interest/interest.component';
//import { CampaignListComponent } from './campaign-list/campaign-list.component';
//import { CreateCompaignComponent } from './compaign/createcompaign.component';
//import { DraftCampaignComponent } from './campaign-list/draftcampaign.component';
//import { ViewCampaignComponent } from './campaign-list/viewcampaign.component';
//import { adTermsComponent } from './terms/terms.component';
// import { PrivacyComponent } from './privacy/privacy.component';
// import { UserResetrpasswordComponent } from './resetpassword/resetpassword.component';

import { AdvHeaderBeforeLoginComponent } from '../common/adv-header-before-login.component';
//import { AdvHeaderBeforeSignupComponent } from '../common/adv-header-before-signup.component';
// // import { HeaderComponent } from '../admin/shared/components/header/header.component';
//import { AdvHeaderComponent } from '../common/adv-header/adv-header.component';
// import { adFooterComponent } from '../common/adfooter.component';
// import { HeaderMenuAccountComponent } from '../common/headermenuAccount.component';

// //popup components
//import { PopupSignupComponent } from '../users/popup/popup-signup.component';
// import { PopupInterestComponent } from './popup/popup.interest.component';
// import { PopupContactComponent } from '../common/popup-contact.component';
// import { AgmCoreModule } from 'angular2-google-maps/core';
@NgModule({
  imports: [
    CommonModule,
    AdvertiserRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedAppModule,
    
  ],
  entryComponents: [
     //   PopupSignupComponent, 
    // PopupInterestComponent, 
    // PopupIphoneComponent,
    // PopupLogoutComponent,
    // PopupLogComponent,
    // PopupSegmentComponent,
    // CoupanCheckComponent,
    // ImageCroperComponent
    // ,DeleteConfirmComponent,
    // ZizDeleteConfirmComponent, 
    // PopupDetailComponent,
    // profileimageCroperComponent,
    // AdminImageCroperComponent,
    // PopupContactComponent
],
  declarations: [
    // TruncatePipe,
    AdvertiserComponent,
    //CampaignListComponent,
    //CreateCompaignComponent,
    //DraftCampaignComponent,
    //ViewCampaignComponent,
    // AdLoginComponent,
    // AdSignupComponent,
    // AdlandingComponent,
    // adTermsComponent,
    //AdvHeaderComponent,
    // adFooterComponent,

    AdvHeaderBeforeLoginComponent,
    //AdvHeaderBeforeSignupComponent,

  ],
  exports: [
    // FooterComponent
  ]
})
export class AdvertiserModule { }



// WEBPACK FOOTER //
// ./src/app/advertiser/advertiser.module.ts